<template>
  <div>
    <div class="config-title">
      {{$t('messageAdd.saveConfig.001')}}
    <span class="configTips">{{$t('messageAdd.saveConfig.020')}}</span>
    </div>
    <template>
      <el-table :data="tableData" border style="width: 100%">
        <el-table-column label="ID" type="index"> </el-table-column>
        <el-table-column prop="name" :label="$t('messageAdd.saveConfig.002')"> </el-table-column>
        <el-table-column prop="type" :label="$t('messageAdd.saveConfig.003')">
          <template slot-scope="scope">
            <span v-if="scope.row.type == 1">{{$t('messageAdd.saveConfig.004')}}</span>
            <span v-if="scope.row.type == 4">{{$t('messageAdd.saveConfig.005')}}</span>
            <span v-if="scope.row.type == 5">{{$t('messageAdd.saveConfig.006')}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" :label="$t('messageAdd.saveConfig.007')"></el-table-column>
        <el-table-column :label="$t('messageAdd.saveConfig.018')">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="handleFindConfig(scope.row.id)">{{$t('messageAdd.saveConfig.008')}}</el-button>
            <el-button type="text" size="small" @click="openQrCode(scope.row.id)">{{$t('messageAdd.saveConfig.009')}}</el-button>
            <el-button type="text" size="small" @click="handleDelConfig(scope.row.id)">{{$t('messageAdd.saveConfig.010')}}</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
      style="margin-top: 10px;"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-sizes="[10, 20, 30, 40]"
      :page-size="pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total">
    </el-pagination>
    </template>
    <!-- 二维码弹框 -->
    <el-dialog :title="$t('messageAdd.saveConfig.011')" @close="handleClose" :visible.sync="isDialogVisible" width="40%" :close-on-click-modal="false" :close-on-press-escape="false">
      <!-- 二维码 -->
      <div class="qrcode-content"> 
        <div class="qrdiv" v-show="qrCodeArr.length != 0">
          <div class="qrcode" v-for="(_, i) in qrCodeArr" :key="i">
            <span class="qrCodeTitle">{{qrCodeTitle}} {{ i+1 }}</span>
            <canvas :ref="`qrCode${i}`" class="qrcode-img"></canvas>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {findPageConfiguration,deleteConfiguration,findConfigurationById} from "@/api/stage"
import { txtToQRtxt } from "@/utils/qrCodeFunctions";
import QRCode from 'qrcode';
import { errorInfo } from '@/utils/common';
export default {
  data() {
    return {
      tableData: [],
      loadData:{
        pageIndex:1,
        pageSize:10
      },
      currentPage:0,
      pageSize:1,
      total:0,
      // configData:{},
      configType:1,
      qrCodeData:{},
      qrCodeTitle:'',
      isDialogVisible:false,
      qrCodeArr:[],
    };
  },
  methods:{
    loadSavePlanData(){
      findPageConfiguration(this.loadData).then(res=>{
        if(res.success){
          this.tableData = res.data.records;
          this.currentPage=res.data.current;
          this.pageSize=res.data.size;
          this.total=res.data.total
        } else {
          errorInfo(`code.${res.errorCode}`)
        }
      })
    },
    handleSizeChange(val) {
      this.loadData.pageSize = val;
      this.loadSavePlanData()
    },
    handleCurrentChange(val) {
      this.loadData.pageIndex = val;
      this.loadSavePlanData()
    },
    // 删除配置
    handleDelConfig(id){
      this.$confirm(this.$t('messageAdd.saveConfig.012'), this.$t('messageAdd.saveConfig.013'), {
        confirmButtonText: this.$t('messageAdd.saveConfig.014'),
        cancelButtonText: this.$t('messageAdd.saveConfig.015'),
        type: 'warning'
      }).then(() => {
        deleteConfiguration(id).then(res=>{
        if(res.success){
          this.$message({
          type: 'success',
          message: this.$t('messageAdd.saveConfig.016')
        });
        this.loadSavePlanData();
        }else{
          this.$message.error(this.$t(`code.${res.errorCode}`)+res.errorInfo?res.errorInfo:'');
        }
      })
        
      }).catch(() => {
        this.$message({
          type: 'info',
          message: this.$t('messageAdd.saveConfig.017')
        });          
      });
    
    },
    // 查看配置
    handleFindConfig(id){
      findConfigurationById(id).then(res=>{
        if(res.success){
          // this.configData=res.data.content;
          this.configType=res.data.type;
          // configType=1,展示配置常用参数
          // configType=4,展示停用系统功能项
          // configType=5,展示自定义配置模式
          if(this.configType==1){
            // 跳转提示
          //   this.$confirm(this.$t('messageAdd.saveConfig.019'), this.$t('messageAdd.saveConfig.013'), {
          //   confirmButtonText: this.$t('messageAdd.saveConfig.014'),
          //   cancelButtonText: this.$t('messageAdd.saveConfig.015'),
          //   type: 'warning'
          // }).then(() => {
            this.$router.push({name:'common',params:{id:res.data.id,name:res.data.name}});
            let noFilterData=res.data.front;
            let parsedData = JSON.parse(noFilterData);
            Object.keys(parsedData).forEach(key => {
              localStorage.setItem(key, JSON.stringify(parsedData[key]));
            });
          // }).catch(() => {
          //   this.$message({
          //   type: 'info',
          //   message: this.$t('messageAdd.saveConfig.017')
          // });   
          // });
          }else if(this.configType==4){
          //   this.$confirm(this.$t('messageAdd.saveConfig.019'), this.$t('messageAdd.saveConfig.013'), {
          //   confirmButtonText: this.$t('messageAdd.saveConfig.014'),
          //   cancelButtonText: this.$t('messageAdd.saveConfig.015'),
          //   type: 'warning'
          // }).then(() => {
            this.$router.push({name:'DeactSysFunction',params:{id:res.data.id,name:res.data.name}})
            let noFilterData=res.data.front;
            // 将数据存放在本地，按照停用系统功能项存储deact
            localStorage.setItem('deact',noFilterData);
          // }).catch(() => {
          //   this.$message({
          //     type: 'info',
          //     message: this.$t('messageAdd.saveConfig.017')
          //   });          
          // });
            
          }else if(this.configType==5){
          //   this.$confirm(this.$t('messageAdd.saveConfig.019'), this.$t('messageAdd.saveConfig.013'), {
          //   confirmButtonText: this.$t('messageAdd.saveConfig.014'),
          //   cancelButtonText: this.$t('messageAdd.saveConfig.015'),
          //   type: 'warning'
          // }).then(() => {
              // 将数据存放在本地，按照自定义配置模式config-存储
            const noFilterData=res.data.front;
            const parsedNoFilterData = JSON.parse(noFilterData);
            this.$router.push({name:'CustomConfigModeChildPage',params:{pages:parsedNoFilterData.pages,id:res.data.id,name:res.data.name}})
            // 将showCustomConfigMode值修改为true；
            Object.keys(parsedNoFilterData).forEach(key => {
              localStorage.setItem(key, JSON.stringify(parsedNoFilterData[key]));
            });
          // }).catch(() => {
          //   this.$message({
          //     type: 'info',
          //     message: this.$t('messageAdd.saveConfig.017')
          //   });          
          // });
          
          }
        }else{
          this.$message.error(this.$t(`code.${res.errorCode}`)+res.errorInfo?res.errorInfo:'');
        }
      })
    },
    // 查看配置码
    openQrCode(id){
      findConfigurationById(id).then(res=>{
        if(res.success){
          this.qrCodeData=res.data.content;
          // 获取二维码内容，处理并展示
          if(res.data.type==4){
            let qrdata={};
            qrdata.ssf=this.handleDeactData(JSON.parse(this.qrCodeData));
            this.qrCodeArr = txtToQRtxt(JSON.stringify(qrdata), '<stn2>');
            this.qrCodeTitle=this.$t('messageAdd.saveConfig.005');
          }else if(res.data.type==5){
            let qrdata=this.handleCustomData(JSON.parse(this.qrCodeData));
            this.qrCodeArr = txtToQRtxt(JSON.stringify(qrdata), '<stn2>');
            this.qrCodeTitle=this.$t('messageAdd.saveConfig.006');
          }else if(res.data.type==1){
            let qrdata=this.handleCommonData(JSON.parse(this.qrCodeData));
            this.qrCodeArr = txtToQRtxt(JSON.stringify(qrdata), '<stn2>');
            this.qrCodeTitle=this.$t('messageAdd.saveConfig.004');
          }
          this.isDialogVisible=true;
          this.forQRcode(this.qrCodeArr);
        }else{
          this.$message.error(this.$t(`code.${res.errorCode}`)+res.errorInfo?res.errorInfo:'');
        }
      })
    },
    // 处理自定义页面数据
    handleCustomData(data){
      // console.log(data);
      
      // let result = {};
      // // 遍历pages中的页面名称和索引
      // data.pages.forEach((item,index) => {
      //  if(data[item.pageName]){
      //   data[item.pageName].id=index+1;
      //   let key = this.handleName(item.pageName);
      //    result[key]=data[item.pageName];
      //  }
      // });
      // return result;
      return data;
    },
    // 处理配置常用参数数据
    handleCommonData(data){
      return data;
    },
    // 处理停用系统功能项数据
    handleDeactData(data){
      // let data = this.cleanEmptyStrArrObj(data);
      return data;
    },
    // 处理转换后的名
    // handleName(pageName){
    //   switch (pageName) {
    //     case 'wifi':
    //     return 'w';
    //     case 'launcher':
    //       return 'ls'; 
    //     case 'mobileNet':
    //       return 'm'; 
    //     case 'displaySet':
    //       return 'd'; 
    //       case 'sound':
    //       return 'v'; 
    //       case 'timeSet':
    //       return 't'; 
    //       case 'USBSet':
    //       return 'u'; 
    //       case 'GeneralSet':
    //       return 'c'; 
    //       case 'featuredSet':
    //       return 'fs'; 
    //       case 'scanningTool':
    //       return 'st'; 
    //       case 'dataWedge':
    //       return 'dw'; 
    //       case 'manageApp':
    //       return 'ma'; 
    //       case 'manageFileCert':
    //       return 'mf';
    //       default:
    //       return null; 
    // }
    // },
    // 处理空数据(数组，对象，字符串)一级
    // cleanEmptyStrArrObj(data) {
    //   const result = {};
    //   for (let key in data) {
    //     if (data.hasOwnProperty(key)) {
    //       const value = data[key];
    //       if (Array.isArray(value) && value.length === 0) {
    //         // 如果是空数组，则不添加到结果对象中
    //       } else if (typeof value === 'object' && value !== null && Object.keys(value).length === 0) {
    //         // 如果是空对象，则不添加到结果对象中
    //       } else if (typeof value === 'string' && value === "") {
    //         // 如果是空字符串，则不添加到结果对象中
    //       } else {
    //         // 否则，添加到结果对象中
    //         result[key] = value;
    //       }
    //     }
    //   }
    //   return result;
    // },
    // 循环生成二维码
    async forQRcode(arr) {
      await this.$nextTick();
      for (let j = 0; j < arr.length; j++) {
        let el = this.$refs[`qrCode${j}`];
        if (Array.isArray(el)) el = el[0];
        if (el) {
          await this.createQRCode(el, arr[j]);
        }
      }
    },
    // 生成二维码
    async createQRCode(el, code) {
      await QRCode.toCanvas(el, code, {
        width: 200,
        margin: 0,
        color: {
          dark: '#000',
          light: '#fff'
        },
        errorCorrectionLevel: 'L'
      });
    },
    // 关闭二维码弹框
    handleClose() {
      this.isDialogVisible = false;
      this.clearQrcode();
      this.qrCodeArr = [];
      this.qrCodeTitle = '';
    },
    // 清除二维码画布
    clearQrcode() {
      for (let i = 0; i < this.qrCodeArr.length; i++) {
        let el = this.$refs[`qrCode${i}`];
        if (Array.isArray(el)) el = el[0];
        if (el && el.getContext) {
          const ctx = el.getContext('2d');
          ctx.clearRect(0, 0, el.width, el.height);
        }
      }
    }
  },
  created(){
    this.loadSavePlanData();
  }
};
</script>
<style scoped>
.configTips{
  font-size: 12px;
  color: red;
}
</style>